import { render } from "./logo.svg?vue&type=template&id=73053320"
const script = {}
script.render = render

export default script